// SprintQualificationMobile.js
import React from "react";
import { getFlagUrl } from "./Utils/getFlagUrl";

const SprintQualificationMobile = ({ data, boldRows, rowRange }) => {
  return (
    <div className="mobile-sprint-qualification">
      {data.map((row, i) => {
        const rowNumber = rowRange[0] + i + 1;
        const isBold = boldRows.includes(rowNumber);
        const isSpacer = row.every(cell => !cell || cell.trim() === "");
        if (isSpacer || i === 0) return null; // přeskoč hlavičku a prázdné řádky

        return (
          <div key={i} className={`sqm-row ${isBold ? "bold-row" : ""}`}>
  <div className="sqm-rank">{row[0]}</div>
  <div className="sqm-name">
  <div className="sqm-last-name">{row[2]}</div>
  <div className="sqm-first-name">{row[3]}</div>

  </div>
  <div className="sqm-right sqm-sprint-right">
  <div className="sprint-col sprint-flag">
    <img src={getFlagUrl(row[4])} alt={row[4]} className="flag-icon" />
  </div>
  <div className="sprint-col sprint-time">
    {row[5]}
  </div>
  <div className="sprint-col sprint-q">
    {row[row.length - 1] === "Q" && <span className="sprint-q-badge">Q</span>}
  </div>
</div>

</div>

        );
      })}
    </div>
  );
};

export default SprintQualificationMobile;
